<template>
    <div class="product-picker-root" v-if="Show" @click="toggle">
        <div class="product-picker-container">
            <div class="product-picker-left" onclick="event.stopPropagation();">
                <div :class="['category-item', { active: activeCategory === category }]" v-for="(category,index) in categoryList" :key="index" @click="showProductList(category)">
                    <p>{{$t("category." + category)}}</p>
                </div>
            </div>
            <div class="product-picker-right" onclick="event.stopPropagation();">  
                <div class="product-item" v-for="(product,index) in productList" :key="index" @click="showQuote(product)">
                    <p>{{product.szShortName}}</p>
                </div>                                                                                                                                                         
            </div>
        </div>
    </div>
</template>

<script>
    import ProductListUtil from '@/utils/productListUtil'
    export default {
        name: "ProductPicker",
        mounted() {
        },
        data() {
            return {
                Show: false,
                activeCategory: ProductListUtil.ProductCategoryList[0],
                categoryList: ProductListUtil.ProductCategoryList,
                productList: ProductListUtil.getProductsByCategory(ProductListUtil.ProductCategoryList[0]),
            }
        },
        methods: {
            toggle(){
                this.Show = !this.Show;
            },
            showProductList(category){
                this.productList = ProductListUtil.getProductsByCategory(category);
                this.activeCategory = category;
            },
            showQuote(product){
                console.log("show quote:", product);
                this.toggle();
                this.$router.push({path: '/home/quoteChart',query: {id: product.uiCodeID,index:0}});
            }
        },
    }
</script>
